<mat-card>
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon svgIcon="file"></mat-icon>
    </div>
    <mat-card-title>Gerenciamento de Erros</mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>
  <div class="container-fluid pt-5">
    <form [formGroup]="bugsForm" (ngSubmit)="search()">
      <fieldset class="border p-2">
        <legend class="w-auto bg-primary">Filtros</legend>
        <div class="row ">
          <div class="col-md-4">
            <ng-select [items]="entityAgreements" [selectOnTab]="true" placeholder="Convênio" bindLabel="formattedName"
              class="customSelect" formControlName="agreement" labelForId="agreement" [searchable]="false" [clearable]="false"
              [loading]="agreementLoading" appearance="outline" [disabled]="agreementLoading" required>
              <ng-template ng-loadingspinner-tmp>
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-4 padding-top-custom">
            <button type="submit" class="btn btn-primary p-4"><i class="flaticon2-search"></i></button>
          </div>
          <div class="col-md-4 pt7 padding-top-custom align-rigth">
            <button type="button" mat-raised-button class="btn btn-info mr-2" (click)="selectAll()"
              [disabled]="!resOk && dataSource.length === 0">
              {{hasSelectedAll ? 'Desmarcar todos' : 'Selecionar Tudo'}}
            </button>

            <button type="button" mat-raised-button class="btn btn-success mr-2" (click)="generateFileProcess()"
              [disabled]="selectedLines.length === 0">Disponibilizar processamento</button>

          </div>
        </div>
      </fieldset>
    </form>

    <div class="row">
      <div class="col-md-12">

        <fieldset class="border p-2 mt-5">
          <legend class="w-auto bg-primary">Dados</legend>
          <ngx-loading-custom></ngx-loading-custom>
          <ngb-alert #staticAlert *ngIf="showAlert" (closed)="showAlert = false">{{ successMessage }}</ngb-alert>
          <div *ngIf="resOk && dataSource.length > 0">
            <simple-list [data]="dataSource" [config]="simpleTableConfig" (reloadTable)="reloadTable($event)"
              (resSelectLine)="resSelectedLines($event)" [selectAllEvent]="eventSelectAll.asObservable()" (reloadTable)="reloadingForAction($event)">
            </simple-list>
          </div>

          <div *ngIf="resOk && dataSource.length === 0">
            <mat-card>
              <p class="notData">Nenhum resultado encontrado para esse filtro</p>
            </mat-card>
          </div>

        </fieldset>
      </div>
    </div>
  </div>
</mat-card>